import CyrillicToTranslit from 'cyrillic-to-translit-js';

export function transliterate(text: string, divider = '-') {
  const trans = new CyrillicToTranslit({ preset: 'ru' });

  return trans.transform(text).replace(/\s/g, divider);
}
